function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.33333 12c1.44919 0 2.66695.95546 3.01277 2.24875L19 14.25v1.5l-1.65364.00025C17.00091 17.04405 15.7829 18 14.33333 18c-1.44956 0-2.66757-.95596-3.01303-2.24975L5 15.75v-1.5l6.32057-.00125C11.66639 12.95546 12.88415 12 14.33333 12zm0 1.5c-.8591 0-1.55555.67157-1.55555 1.5s.69644 1.5 1.55555 1.5 1.55556-.67157 1.55556-1.5-.69645-1.5-1.55556-1.5zM9.66667 6c1.44956 0 2.66757.95596 3.01303 2.24975L19 8.25v1.5l-6.32057.00125C12.33361 11.04454 11.11585 12 9.66667 12c-1.44919 0-2.66695-.95546-3.01277-2.24875L5 9.75v-1.5l1.65364-.00025C6.99909 6.95595 8.2171 6 9.66667 6zm0 1.5c-.85911 0-1.55556.67157-1.55556 1.5s.69645 1.5 1.55556 1.5c.8591 0 1.55555-.67157 1.55555-1.5s-.69644-1.5-1.55555-1.5z"
});

var SvgFiltr = function SvgFiltr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFiltr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Filtr.20833856.svg";
export { ForwardRef as ReactComponent };